import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'


import BoxSection from '../Layout/BoxSection'

class Aprobacion extends Component {
	render() {
        const { documento, enums } = this.props
        if (!documento) return null

		return (
            <div>
                <BoxSection key={ `bs1[${documento.get('id')}]` } title={ <span>{ documento.getIn(['aprobacion','estado']) === 2 ? <FontAwesome name="check" style={{ color: 'green' }} /> : documento.getIn(['aprobacion','estado']) === 0 ? <FontAwesome name="times"  style={{ color: 'red' }} /> : '' } Solicitud de aprobación del documento al proveedor</span> }>
                    <div className="row">
                        <div className="col-md-12">
                            <h4>Aprobación { documento.getIn(['proveedore','nombre']) } { enums.aprobaciones.estados[documento.getIn(['aprobacion','estado'])] }{ documento.getIn(['aprobacion','estado']) === 1 ? '' : <span> &bull; { moment(documento.getIn(['aprobacion','fecha'])).format('YYYY-MM-DD HH:mm') }</span> }</h4>
                        </div>
                        <div className="col-md-12">
                            <span>Solicitada por <b>{ documento.getIn(['solicitude', 'responsable_compras', 'fullname']) }</b></span> &bull; <span><a href={ `mailto:${documento.getIn(['solicitud', 'responsable_compras', 'email'])}` }>{ documento.getIn(['solicitude', 'responsable_compras', 'email']) }</a></span>
                        </div>
                    </div>
                </BoxSection>
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        documento: state.documentos.getIn(['modalSummary', 'data']),
        enums: state.common.get('enums').toJS(),
    }
}

function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Aprobacion)


// WEBPACK FOOTER //
// ./src/components/Documentos/Aprobacion.jsx